import { Center } from "@chakra-ui/react";
import React, { Component } from "react";
import Header from "../../../components/Header";
import {
  ConsultaContainerText,
  ContainerConsulta,
  ContainerConsultaBox,
} from "./styles";
import { cpfMask } from "../../../services/mask";
import {
  ListaEmpresas,
  ListaFunilDeVenda,
  ListaOrcamentoPedido,
  runVerificaAutenticacao,
} from "../../../services/api";
import ModalConsulta from "./ModalConsulta";
import FormConsulta from "./FormConsulta";

const loading = "../../images/loading-verde.gif";
class Consulta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view_loading: false,
      isOpen: false,
      onOpen: false,
      onClose: false,
      dados: [],
      numero_proposta: null,
      nome_parceiro: null,
      nome_cliente: null,
      codigo_parceiro: null,
      cpf_cnpj_parceiro: null,
      email_parceiro: null,
      estimativa_valor: null,
      orcamentos_ativos: null,
      codigo_empresa: null,
      data_inicio: null,
      data_fim: null,
      codigo_status_pedido: null,
      proposta_especial: null,
      pendente: null,
      todos: null,
      proposta_enviar: null,
      funilVendas: [],
      listaDeEmpresa: [],
    };
  }

  //32 pedido
  //33 orçamento

  componentDidMount() {
    runVerificaAutenticacao();
    this.getFunilVendas();
    this.getListaEmpresas();
  }

  ifNull(a, b) {
    if (a === null || a === "" || a === undefined) {
      return b;
    } else {
      return a;
    }
  }

  getOrcamentoPedidos = async (onOpen) => {
    this.setState({ dados: [] });
    //validação se pelo menos 1 filtro ou mais está preenchido se sim fazer o post,
    //alert para preencher as informações.
    if (
      this.ifNull(this.state.numero_proposta, "") === "" &&
      this.ifNull(this.state.nome_parceiro, "") === "" &&
      this.ifNull(this.state.nome_cliente, "") === "" &&
      this.ifNull(this.state.codigo_parceiro, "") === "" &&
      this.ifNull(this.state.cpf_cnpj_parceiro, "") === "" &&
      this.ifNull(this.state.email_parceiro, "") === "" &&
      this.ifNull(this.state.estimativa_valor, "") === "" &&
      this.ifNull(this.state.codigo_status_pedido, "") === "" &&
      this.ifNull(this.state.codigo_empresa, "") === "" &&
      this.ifNull(this.state.data_inicio, "") === "" &&
      this.ifNull(this.state.data_fim, "") === "" &&
      this.ifNull(this.state.proposta_especial, "") === "" &&
      this.ifNull(this.state.pendente, "") === "" &&
      this.ifNull(this.state.todos, "") === "" &&
      this.ifNull(this.state.proposta_enviar, "") === "" &&
      this.ifNull(this.state.orcamentos_ativos, "") === ""
    ) {
      alert("É obrigatório preencher ao menos um campo!");
    } else {
      onOpen();
      try {
        await this.setState({ view_loading: true });
        const params = {
          numero_proposta: this.state.numero_proposta,
          nome_parceiro: this.state.nome_parceiro,
          nome_cliente: this.state.nome_cliente,
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          estimativa_valor: this.state.estimativa_valor,
          orcamentos_ativos: this.state.orcamentos_ativos,
          codigo_status_pedido: this.state.codigo_status_pedido,
          codigo_empresa: this.state.codigo_empresa,
          data_inicio: this.state.data_inicio,
          data_fim: this.state.data_fim,
          proposta_especial: this.state.proposta_especial,
          pendente: this.state.pendente,
        };

        const response = await ListaOrcamentoPedido.post("", params);

        console.log(params);
        let data = response.data;
        this.setState({
          dados: data,
        });
        await this.setState({ view_loading: false });
      } catch (error) {
        console.log(Object.keys(error), error.message);
      }
    }
  };

  getFunilVendas = async () => {
    try {
      const response = await ListaFunilDeVenda.post("", {});
      let data = response.data;

      this.setState({ funilVendas: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getListaEmpresas = async () => {
    try {
      const response = await ListaEmpresas.get();
      var data = response.data;

      this.setState({
        listaDeEmpresa: data,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  onChange = (e, value, type = "input") => {
    if (type === "select") {
      this.setState({
        [value]: e.target.options[e.target.options.selectedIndex].value,
      });
    } else if (type === "mask") {
      this.setState({ [value]: cpfMask(e.target.value) });
    } else if (type === "checked") {
      this.setState({ [value]: e.target.checked });
    } else {
      this.setState({ [value]: e.target.value });
    }
  };

  render() {
    return (
      <>
        <ContainerConsulta>
          <ConsultaContainerText>
            <h1>
              <strong>CONSULTA </strong>(ORÇAMENTOS/PEDIDOS)
            </h1>
          </ConsultaContainerText>
          <Center>
            <ContainerConsultaBox>
              <FormConsulta
                onChange={this.onChange}
                state={this.state}
                getFunilVendas={this.getFunilVendas}
                getListaEmpresas={this.getListaEmpresas}
              />
              <ModalConsulta
                loading={this.state.view_loading}
                dados={this.state.dados}
                getOrcamentoPedidos={this.getOrcamentoPedidos}
              />
            </ContainerConsultaBox>
          </Center>
        </ContainerConsulta>
      </>
    );
  }
}

export default Consulta;
